import { getFieldErrorNames } from '../../utils/generic';
import { useEffect } from 'react';
import { useFormikContext } from 'formik';

/*https://codesandbox.io/s/scroll-to-input-formik-failed-submission-gnehr?file=/src/App.js:1217-1235*/
const ScrollToFieldError = () => {
  const scrollBehavior = { behavior: 'smooth', block: 'center' } as any;
  const { isValid, errors, isValidating } = useFormikContext();
  useEffect(() => {
    if (isValid || isValidating) return;

    const fieldErrorNames = getFieldErrorNames(errors);

    if (fieldErrorNames.length <= 0) return;

    const elementInput = document.querySelector(
      `input[name='${fieldErrorNames[0]}'],` + // for input fields or buttons
        `div[id='error-${fieldErrorNames[0]}']` // for the error elements of the ubisoft account fields
    );

    const elementSelect = elementInput
      ? elementInput
      : document.querySelector(`div[id='${fieldErrorNames[0]}']`); // for reactSelect component

    //this part is for survey candidateGameExperiences
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const index = errors.candidateGameExperiences?.findIndex((ge: any) => ge);
    const element =
      elementSelect ||
      document
        .querySelector('#candidateGameExperiences')
        ?.getElementsByClassName('btn-yes-no')[index];

    if (!element) return;

    // Scroll to first known error into view
    element.scrollIntoView(scrollBehavior);
  }, [isValidating]);

  return null;
};

export default ScrollToFieldError;
